import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './assets/font-awesome/css/fontawesome.min.css';
import './css/style.scss';

import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);


reportWebVitals();
